/* SPACEREBELS – "Complete the look" (PL: Kompletuj wnętrze; IT: Completa l'arredamento) – wersja Dawn 16
   Dodawanie zestawu do koszyka (/cart/add.js) + filtr pomieszczeń.
   - cart_type = drawer  → odświeża i otwiera szufladę koszyka Dawn (<cart-drawer>)
   - cart_type = notification → otwiera powiadomienie Dawn (<cart-notification>, pierwszy produkt zestawu),
     odświeża licznik koszyka i pokazuje komunikat z linkiem do koszyka.
   - cart_type = page → odświeża licznik (#cart-icon-bubble) + komunikat z linkiem do koszyka.
   Dawn 16: zdarzenia window.StandardEvents (CartLinesUpdateEvent / CartErrorEvent) jak w product-form.js – jeśli dostępne.
   Teksty (EN/IT) przychodzą z Liquid: <script type="application/json" data-sr-promo-strings> (klucze sr_promo.bundles.*).
   Adresy z prefiksem języka: Shopify.routes.root (np. /en/). */
(() => {
  const strings = () => {
    if (window.__srPromoStrings) return window.__srPromoStrings;
    let s = {};
    try { s = JSON.parse(document.querySelector('[data-sr-promo-strings]')?.textContent || '{}'); } catch (e) {}
    return (window.__srPromoStrings = s);
  };

  if (!window.customElements.get('sr-bundle-add')) {
    class SrBundleAdd extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.msg = this.querySelector('[data-msg]');
        this.button?.addEventListener('click', () => this.add());
      }

      setMsg(text, ok, withLink) {
        if (!this.msg) return;
        this.msg.textContent = text || '';
        this.msg.className = 'sr-bundle__msg ' + (text ? (ok ? 'sr-bundle__msg--ok' : 'sr-bundle__msg--err') : '');
        if (text && withLink) {
          const a = document.createElement('a');
          a.href = this.dataset.cartUrl || (((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart');
          a.className = 'sr-bundle__cartlink';
          a.textContent = this.dataset.cartLabel || strings().cartLink || '';
          this.msg.append(' ', a);
        }
      }

      // Dawn 16 Standard Events (analityka / aplikacje) – bezpiecznie pomijane, gdy brak window.StandardEvents
      linesUpdateEvent(items) {
        try {
          const { CartLinesUpdateEvent } = window.StandardEvents || {};
          if (!CartLinesUpdateEvent) return null;
          const deferred = CartLinesUpdateEvent.createPromise();
          deferred.promise.catch(() => {});
          this.dispatchEvent(new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: items.map((i) => ({ merchandiseId: String(i.id), quantity: i.qty || 1 })),
            promise: deferred.promise
          }));
          return deferred;
        } catch (e) { return null; }
      }

      resolveLinesUpdate(deferred) {
        if (!deferred) return;
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return;
        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        const p = typeof CartItems !== 'undefined' && CartItems.fetchCartData
          ? CartItems.fetchCartData()
          : fetch(`${root}cart.js`).then((r) => r.json());
        p.then((cart) => {
          if (!cart || !cart.currency) return deferred.reject(new Error('Missing currency in cart response'));
          deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart) });
        }).catch((e) => deferred.reject(e));
      }

      errorEvent(message, code) {
        try {
          const { CartErrorEvent } = window.StandardEvents || {};
          if (CartErrorEvent) this.dispatchEvent(new CartErrorEvent({ error: message, code }));
        } catch (e) {}
      }

      sectionHTML(html, selector) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const el = doc.querySelector(selector);
        return el ? el.innerHTML : null;
      }

      async add() {
        let items;
        try { items = JSON.parse(this.dataset.items || '[]'); } catch (e) { items = []; }
        if (!items.length) return;

        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        const bundleName = this.dataset.bundle || strings().setFallback || 'Set';
        const drawer = document.querySelector('cart-drawer');
        const notification = !drawer ? document.querySelector('cart-notification') : null;
        const sections = drawer
          ? ['cart-drawer', 'cart-icon-bubble']
          : notification
            ? ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble']
            : ['cart-icon-bubble'];
        const deferred = this.linesUpdateEvent(items);

        this.button.setAttribute('aria-busy', 'true');
        this.setMsg('');

        try {
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({
              // _zestaw = ukryty atrybut pozycji (widoczny w zamówieniu w adminie), jak w PL
              items: items.map((i) => ({ id: i.id, quantity: i.qty || 1, properties: { _zestaw: bundleName } })),
              sections: sections.join(','),
              sections_url: window.location.pathname
            })
          });
          const json = await response.json();

          if (!response.ok || json.status) {
            const err = json.description || json.message || strings().error || 'Error';
            this.errorEvent(err, 'INVALID');
            deferred?.reject(new Error(err));
            this.setMsg(err, false);
            return;
          }
          this.resolveLinesUpdate(deferred);

          // Dawn: szuflada koszyka (gdy cart_type = drawer)
          if (drawer && typeof drawer.renderContents === 'function' && json.sections && json.sections['cart-drawer']) {
            drawer.classList.remove('is-empty');
            const first = (json.items && json.items[0]) || {};
            drawer.renderContents({ ...first, id: first.product_id || first.id, sections: json.sections });
            this.setMsg(this.dataset.successText || strings().success || '', true, false);
            return;
          }

          // Dawn: notification – popup z pierwszym produktem zestawu + przycisk „Zobacz koszyk (N)”
          if (notification && typeof notification.renderContents === 'function' && json.sections && json.sections['cart-notification-product']) {
            const first = (json.items && json.items[0]) || {};
            try {
              notification.renderContents({ ...first, sections: json.sections });
              this.setMsg(this.dataset.successText || strings().success || '', true, true);
              return;
            } catch (e) { /* fallback niżej */ }
          }

          // Dawn: page (lub błąd powiadomienia) – odśwież licznik w nagłówku
          const bubble = document.getElementById('cart-icon-bubble');
          const bubbleHTML = json.sections && json.sections['cart-icon-bubble'];
          if (bubble && bubbleHTML) {
            const inner = this.sectionHTML(bubbleHTML, '.shopify-section');
            if (inner !== null) bubble.innerHTML = inner;
          }
          // Dawn pub/sub (constants.js + pubsub.js) – inne komponenty mogą nasłuchiwać zmian koszyka
          try {
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sr-bundle-add', cartData: json });
            }
          } catch (e) {}
          this.setMsg(this.dataset.successText || strings().success || '', true, true);
        } catch (e) {
          this.errorEvent(e.message || 'Network error', 'SERVICE_UNAVAILABLE');
          deferred?.reject(e);
          this.setMsg(strings().network || 'Error', false);
        } finally {
          this.button.removeAttribute('aria-busy');
        }
      }
    }
    window.customElements.define('sr-bundle-add', SrBundleAdd);
  }

  if (!window.customElements.get('sr-bundle-filter')) {
    class SrBundleFilter extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (e) => {
          const chip = e.target.closest('[data-room]');
          if (!chip) return;
          const room = chip.dataset.room;
          this.querySelectorAll('[data-room]').forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
          const grid = document.getElementById(this.getAttribute('aria-controls'));
          grid?.querySelectorAll('[data-bundle-room]').forEach((card) => {
            const rooms = (card.dataset.bundleRoom || '').split('|');
            card.hidden = room !== '*' && !rooms.includes(room);
          });
        });
      }
    }
    window.customElements.define('sr-bundle-filter', SrBundleFilter);
  }
})();
